import { useContext } from 'react'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog, faPencil, faSync, faTrashAlt,
} from '@fortawesome/pro-light-svg-icons'

import { IconWithMenu, Link } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useAgencyPortal from '@hooks/useAgencyPortal'

import PageContext from '@contexts/pageContext'

const confirmGenerateToken = (
  generateAgencyPortalAuthToken: (payload: HandleCallbackActionParams) => Promise<object>,
  generateFn: ()=> void,
) => {
  const generateAgencyPortalAuthTokenPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Token Generated',
  }

  swal
    .fire({
      confirmButtonColor: '#43AC6A',
      confirmButtonText: 'Yes, generate it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure? This will replace the existing authentication token.',
      title: 'Generate Token?',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2345
        generateAgencyPortalAuthToken(generateAgencyPortalAuthTokenPayload)
      }
    })
}

type AgencyPortalActionsProps = {
  assignedPortalIds: [],
  useAgencyPortalPayload: ReturnType<typeof useAgencyPortal>,
}

const AgencyPortalActions = (props: AgencyPortalActionsProps) => {
  const {
    assignedPortalIds,
    useAgencyPortalPayload,
  } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      generateAgencyPortalAuthToken,
    },
  } = pageContext

  const {
    callbacks: {
      createOrEditAgencyPortal,
      deleteAgencyPortal: deleteFn,
      generateAuthToken,
    },
  } = useAgencyPortalPayload

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This will remove the portal from this agency.',
      deleteString: 'Remove',
      entityName: 'Agency Portal',
    },
  }

  return (
    <IconWithMenu
      boxProps={{ position: 'relative' }}
      icon={(
        <Link greyLink>
          <FontAwesomeIcon icon={faCog} />
        </Link>
      )}
      shouldUsePortal
    >
      {/*
       // @ts-expect-error TS2741 */}
      <IconWithMenu.Menu closeOnClick>
        <Link
          key="generate_token"
          onClick={() => confirmGenerateToken(generateAgencyPortalAuthToken, generateAuthToken)}
        >
          <FontAwesomeIcon icon={faSync} /> Generate Token
        </Link>

        <Link
          key="remove_portal"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
        >
          <FontAwesomeIcon icon={faTrashAlt} /> Remove Portal
        </Link>

        <Link
          key="edit_portal"
          onClick={() => createOrEditAgencyPortal({ assignedPortalIds })}
        >
          <FontAwesomeIcon icon={faPencil} /> Edit Portal
        </Link>
      </IconWithMenu.Menu>
    </IconWithMenu>
  )
}

export default AgencyPortalActions
